export default __webpack_public_path__ + "static/media/gh.63bfbfee.svg";